import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/combinedKidneyPancreas";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	combinedKidneyPancreas: {
		id: "ktx.combinedKidneyPancreas.title",
		defaultMessage: "Kombinált Vese-Hasnyálmirigy"
	},
	summary: {
		id: "ktx.combinedKidneyPancreas.field.summary",
		defaultMessage:
			"Lelet tartalma (C Peptid, Pancreas szigetsejt elleni antitest, tirozin foszfatáz A2(IA2) elleni antitest, inzulin elleni antitest, cink transzporter 8 elleni antitest, Glutaminsav dekarboxiláz elleni antitest)"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["summary"],
		label: messages.summary,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_combinedKidneyPancreas",
	value: {
		schemaId: "combinedKidneyPancreas",
		title: messages.combinedKidneyPancreas,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
